/*
  F&NT · Referidos y embajadores del lado del amigo (v24, 15 oct 2026 · embajadores v32, 20 oct 2026)
  1) Si la página abre con ?ref=CÓDIGO (enlaces /r/código), guarda el código 30 días en este navegador
     y aplica el código de descuento al carrito (/discount/CÓDIGO).
     Códigos válidos: referidos (letras + 4 dígitos) o embajadores (solo letras, 3 a 12, que estén en la lista
     window.__fntEmb del metacampo de tienda fnt.embajadores y cuya fecha «desde» ya llegó).
  2) Mientras el código siga vigente, lo escribe en el atributo del carrito _referido (llega al pedido;
     lo leen los Flows «Referidos · abonar $150» y «Embajadores · abonar venta», FNT_shopify_web §6). Al vencer, lo borra.
  3) Barra «BETO TE REGALÓ $100» en toda la tienda (menos en /pages/regalo): se cierra con la ×
     y desaparece a los 30 días o si el cliente con sesión ya tiene pedidos. Con un código de embajador
     usa su nombre para mostrar de la lista («Sofía», «José María»).
  Sin datos personales: solo el código. Reglas: FNT_credito_y_referidos 6.1 y 6.3 · FNT_embajadores 2.1.
*/
(function () {
  'use strict';
  if (window.__fntReferidos) return;
  window.__fntReferidos = true;

  var K = 'fnt_referido', K_CERRADO = 'fnt_referido_cerrado', K_ESCRITO = 'fnt_referido_escrito';
  var DIAS30 = 30 * 864e5;
  var REF = /^[A-Z]{2,10}\d{4}$/;
  var EMB_RE = /^[A-Z]{3,12}$/;
  var EMB = (window.__fntEmb && typeof window.__fntEmb === 'object') ? window.__fntEmb : {};
  var LS = window.localStorage, SS = window.sessionStorage;
  var ahora = Date.now();

  function get(s, k) { try { return JSON.parse(s.getItem(k) || 'null'); } catch (e) { return null; } }
  function set(s, k, v) { try { s.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function del(s, k) { try { s.removeItem(k); } catch (e) {} }

  function hoy() {
    var d = new Date();
    function p(n) { return (n < 10 ? '0' : '') + n; }
    return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
  }
  // Embajador: solo letras, en la lista y con su fecha de inicio cumplida
  function esEmbajador(c) {
    var e = EMB[c];
    return !!(e && EMB_RE.test(c) && (!e.desde || hoy() >= e.desde));
  }
  function valido(c) { return REF.test(c || '') || esEmbajador(c || ''); }

  var compras = Number(window.__fntCompras || 0);
  var params;
  try { params = new URLSearchParams(location.search); } catch (e) { params = null; }
  var nuevo = params ? String(params.get('ref') || '').trim().toUpperCase() : '';

  // 1. Llegada por enlace: guarda el código (el último enlace manda) y aplica el descuento
  //    si no viene ya aplicado (el enlace /r/ pasa por /discount/ antes de llegar). Primero el
  //    descuento y después el atributo: si van juntos, cada uno crea su carrito y uno se pierde.
  var listo = Promise.resolve();
  if (nuevo && valido(nuevo) && compras === 0) {
    set(LS, K, { c: nuevo, t: ahora });
    var dc = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    if (!dc || decodeURIComponent(dc[1]).toUpperCase() !== nuevo) {
      try { listo = fetch('/discount/' + encodeURIComponent(nuevo), { credentials: 'same-origin', redirect: 'manual' }).catch(function () {}); } catch (e) {}
    }
  }

  var r = get(LS, K);
  var vigente = !!(r && valido(r.c || '') && ahora - (r.t || 0) < DIAS30 && compras === 0);
  if (r && !vigente) del(LS, K);
  var codigo = vigente ? r.c : '';

  // 2. Atributo del carrito _referido
  function carritoActual() {
    var m = document.cookie.match(/(?:^|;\s*)cart=([^;]+)/);
    return m ? m[1] : '';
  }
  function escribir(forzar) {
    var valor = codigo;
    var hecho = get(SS, K_ESCRITO);
    var cart = carritoActual();
    if (!forzar && hecho && hecho.v === valor && hecho.cart === cart && cart) return;
    if (!valor && !get(LS, K_ESCRITO)) return; // nunca hubo código: no se toca el carrito
    try {
      window.fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { _referido: valor } }),
        keepalive: true
      }).then(function (res) {
        if (!res || !res.ok) return;
        set(SS, K_ESCRITO, { v: valor, cart: carritoActual() });
        if (valor) set(LS, K_ESCRITO, true); else del(LS, K_ESCRITO);
      }).catch(function () {});
    } catch (e) {}
  }
  listo.then(function () { escribir(false); });

  // Al agregar al carrito y al ir a pagar se vuelve a escribir (por si el carrito cambió)
  var fetchPrevio = window.fetch;
  if (codigo && typeof fetchPrevio === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = fetchPrevio.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (res) { if (res && res.ok) setTimeout(function () { escribir(true); }, 300); }).catch(function () {});
      }
      return p;
    };
  }
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (codigo && t && t.closest && t.closest('[name="checkout"], a[href*="/checkout"]')) escribir(true);
  }, true);

  // 3. Barra del amigo y textos de /pages/regalo
  function nombre(c) {
    if (esEmbajador(c) && EMB[c].n) return String(EMB[c].n);
    var n = String(c || '').replace(/\d+$/, '');
    return n === 'AMIGO' ? '' : n;
  }
  window.FNTReferidos = { codigo: codigo, nombre: nombre(codigo), embajador: esEmbajador(codigo) };

  function rellenarRegalo() {
    var n = nombre(codigo);
    if (!n) return;
    document.querySelectorAll('[data-fnt-ref="quien"]').forEach(function (el) { el.textContent = n + ' te regaló'; });
  }

  function barra() {
    if (!codigo) return;
    if (/^\/pages\/regalo/.test(location.pathname)) return;
    if (get(LS, K_CERRADO) === codigo) return;
    var n = nombre(codigo);
    var css = '.fnt-refbar{display:flex;align-items:center;gap:12px;padding:10px 16px;background:#CDB48E;color:#161616;position:relative;z-index:30}' +
      '.fnt-refbar__ico{flex:0 0 22px;width:22px;height:22px}' +
      '.fnt-refbar__txt{flex:1;display:flex;flex-direction:column;gap:2px;min-width:0}' +
      '.fnt-refbar__t{font-family:HelveticaCondensedmMedium,HelveticaCondensed,sans-serif;font-size:15px;letter-spacing:.04em;text-transform:uppercase;line-height:1.15}' +
      '.fnt-refbar__s{font-size:12.5px;line-height:1.35;color:#2e2a22}' +
      '.fnt-refbar__x{flex:0 0 44px;width:44px;height:44px;display:flex;align-items:center;justify-content:center;background:none;border:0;padding:0;color:#161616;cursor:pointer}' +
      '@media (min-width:750px){.fnt-refbar{justify-content:center}.fnt-refbar__txt{flex:0 1 auto;flex-direction:row;align-items:baseline;gap:12px}.fnt-refbar__x{position:absolute;right:8px;top:50%;transform:translateY(-50%)}}';
    var st = document.createElement('style');
    st.textContent = css;
    document.head.appendChild(st);
    var el = document.createElement('div');
    el.className = 'fnt-refbar';
    el.setAttribute('role', 'region');
    el.setAttribute('aria-label', 'Regalo de referidos');
    el.innerHTML =
      '<svg class="fnt-refbar__ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="13" rx="1"></rect><path d="M3 12h18M12 8v13"></path><path d="M12 8c-2-4-6-4-6-1.5S9 8 12 8zM12 8c2-4 6-4 6-1.5S15 8 12 8z"></path></svg>' +
      '<div class="fnt-refbar__txt"><span class="fnt-refbar__t"></span><span class="fnt-refbar__s">Primera compra desde $999 · ya en tu carrito</span></div>' +
      '<button type="button" class="fnt-refbar__x" aria-label="Cerrar aviso"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg></button>';
    el.querySelector('.fnt-refbar__t').textContent = n ? n + ' te regaló $100' : 'Te regalaron $100';
    el.querySelector('.fnt-refbar__x').addEventListener('click', function () {
      set(LS, K_CERRADO, codigo);
      el.remove();
    });
    document.body.insertBefore(el, document.body.firstChild);
  }

  function iniciar() { rellenarRegalo(); barra(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
